import React, { useEffect, useState } from 'react';
import { SortCondition } from 'shared/enums';
import { dataForRvdTable } from 'shared/helpers/utils';
import { usePullSort } from 'shared/hooks';
import { Spin } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import CommonTable from 'features/tables/commonTable';
import { TCommonColumns } from 'shared/types/overtime.types';
import { RvdStatusesBack } from 'shared/enums/rvd';
import { useLazyGetRvdQuery } from 'app/services/edpApiV1/rvd';
import SearchComponent from 'shared/components/search/rvd-overtime';
import { ISearchData, TPreparedRvd } from 'shared/types/rvd.types';
import { useAppSelector } from 'app/store';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import BadgeData from './badgeData/BadgeData';
import style from './index.module.scss';

const RvdInProgress = () => {
  const [search, setSearch] = useState<ISearchData>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [sortInfo, trigger] = usePullSort();
  const [getRvds, { data, isFetching, isLoading }] = useLazyGetRvdQuery();
  const navigate = useNavigate();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const onclickToRow = (id: number) => {
    navigate(`/rvd/update/${id}`);
  };

  useEffect(() => {
    const newData = {};
    Object.keys(search).forEach(key => {
      if (search[key]) {
        newData[key] = search[key];
      }
    });
    getRvds({
      page: currentPage,
      size: currentSize,
      orderDate: sortInfo.value ? sortInfo.value : undefined,
      type: 'my',
      allAvailableOrganizations,
      ...newData,
    });
  }, [currentPage, currentSize, getRvds, search, sortInfo.value, allAvailableOrganizations]);

  const onSearch = (data: ISearchData) => {
    setSearch({ ...data });
  };

  const columns: TCommonColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      sortDirections: [SortCondition.ASCEND, SortCondition.DESCEND],
      sorter: true,
      onHeaderCell: _ => ({
        onClick: () => trigger(),
      }),
    },
    {
      title: 'Количество сотрудников',
      dataIndex: 'count',
      key: 'count',
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (id, record) => (
        <BadgeData
          rvd={data?.data.find(elem => {
            return record.id == elem.id;
          })}
        ></BadgeData>
      ),
    },
    {
      title: 'Действие',
      dataIndex: 'actions',
      key: 'actions',
      render: (_, record) => (
        <Link
          to={`/rvd/load/${record.id}`}
          onClick={e => {
            e.stopPropagation();

            if ((record as TPreparedRvd).status !== RvdStatusesBack.NOT_LOADED_CPRODUCT) {
              e.preventDefault();
              return;
            }
          }}
          className={
            (record as TPreparedRvd).status !== RvdStatusesBack.NOT_LOADED_CPRODUCT ? style.disabled : 'loadButton'
          }
        >
          Выгрузить
        </Link>
      ),
    },
    {
      title: 'Комментарий',
      dataIndex: 'userComment',
      key: 'userComment',
      render: (userComment: string) => {
        return (
          <div title={userComment} className="rvd-user-comment">
            {userComment}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <SearchComponent onSearch={onSearch} />
      <Spin spinning={isLoading && isFetching}>
        <CommonTable
          dataSource={dataForRvdTable(data?.data ? data.data : [])}
          columns={columns}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          total={data?.pagination.total}
          setCurrentSize={setCurrentSize}
          currentSize={currentSize}
          onclickToRow={(id: number) => onclickToRow(id)}
        />
      </Spin>
    </>
  );
};

export default RvdInProgress;
